<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__update-item"
  >
    <template #pic>
      <div class="label-pic is-purple">
        <icon
          data="@icon/task-icon.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
          color="#6A1B9A"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="notification.itemUrl"
        >
          Item {{ notification.itemSequenceNumber }}
        </a>
        Task List has been updated
      </BaseSubHeading>
    </template>
    <template #content>
      <div class="notification-task__list">
        <div
          v-for="(task, index) in tasks"
          :key="index"
          class="notification-task__content"
        >
          <BaseSubHeading
            size="medium"
            color="monochrome-07"
            weight="400"
            class="notification-task__content__left"
          >
            <span
              v-if="notification.getTaskStatus(task)"
              class="notification-task__status"
              :class="[`is_${notification.getTaskStatus(task).id.toLowerCase()}`]"
            >
              {{ notification.getTaskStatus(task).label }}
            </span>

            <span class="notification-task__name">
              {{ task.name }}
            </span>
          </BaseSubHeading>

          <BaseSubHeading
            size="medium"
            color="monochrome-06"
            weight="500"
            class="notification-task__content__right"
          >
            <span class="notification-task__type">
              {{ $t(`task.types.${task.type.toLowerCase()}`) }}
            </span>
            <span class="notification-task__estimation is-estimation">
              <span class="is-opacity notification-task__estimation__old">
                {{ task.oldEstimation }}
              </span>

              <span
                v-if="task.oldEstimation === 0 || task.oldEstimation"
                class="is-bold"
              >
                >
              </span>
              <span class="is-bold">
                {{ getFormattedEstimation(task.estimatedHours) }}
              </span>
            </span>
          </BaseSubHeading>
        </div>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationItem } from "@/models"

@Options({
  name: "ITEM_UPDATE_TASKS",
  components: {
    NotificationTemplate
  }
})
export default class ITEM_UPDATE_TASKS extends Vue {
  @Prop() readonly notification: NotificationItem
  getFormattedEstimation(estimatedHours: number | undefined): string {
    if (estimatedHours === undefined) {
      return "-"
    }
    if (estimatedHours === 0) {
      return "0 hr"
    }
    return `${estimatedHours} hr`
  }

  get tasks() {
    return this.notification.tasks
  }
}
</script>
